/*!
   angular-form-gen v0.1.0-beta.7
   (c) 2015 (null) McNull https://github.com/McNull/angular-form-gen
   License: MIT
*/
(function(angular) {
